module.exports = __webpack_public_path__ + "img/error6.65fd3b76.png";